<div class="card card-custom">
  <div class="card-header">
    <div *ngIf="data.length > 1" class="card-title mr-0">
      <span class="label label-xl label-inline label-light-warning mr-3" style="width: 70px"
        >Before</span
      >
    </div>
    <div class="card-title mr-0">
      <span
        *ngIf="data.length > 1"
        class="label label-xl label-inline label-light-success mr-3"
        style="width: 70px"
        >After</span
      >
    </div>
  </div>
  <div
    class="card-body overflow-hidden d-flex align-items-center p-0"
    [ngClass]="{
      'justify-content-between': data.length > 1,
      'justify-content-center': data.length <= 1
    }"
  >
    <kt-patient-add *ngIf="data.length > 1" [patient]="data[1].patient"></kt-patient-add>
    <kt-patient-add [patient]="data[0].patient"></kt-patient-add>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button type="button" mat-raised-button (click)="close()">
      <span translate="GLOBAL.CLOSE">Close</span>
    </button>
  </div>
</div>
